var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgTrashIcon = function SvgTrashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 15c0 .555.445 1 1 1h10c.555 0 1-.445 1-1V7H2v8zM15.992 5H16v1H0V5h.008A1.99 1.99 0 012 3.062h2V2c0-1.102.898-2 2-2h4c1.102 0 2 .898 2 2v1.063h2A1.99 1.99 0 0115.992 5zM10 3.062V2H6v1.063h4z"
  })));
};
export default SvgTrashIcon;